import { ContactPage } from "@components/pages/ContactPage"
import { SiteShell } from "@components/SiteShell"
import { contactPageQueryOptions } from "@data/publicPageDataQuery"
import { createFileRoute } from "@tanstack/react-router"
import { localizedRouteHead } from "@utils/routeHead"
import { pageLabels } from "@utils/routeLabels"

export const Route = createFileRoute("/$locale/contact/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(contactPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "contact", path: `/${locale}/contact` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: routeLocale } = Route.useParams()
  const locale = routeLocale as "en" | "ja"
  const data = Route.useLoaderData()
  const labels = pageLabels(locale, "contact")
  return (
    <SiteShell
      locale={locale}
      page={labels.page}
    >
      <ContactPage
        data={data}
        locale={locale}
      />
    </SiteShell>
  )
}
